module.exports = __webpack_public_path__ + "img/galery16.0a0c20f8.jpg";